
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/education/tag/[slug]",
      function () {
        return require("private-next-pages/education/tag/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/education/tag/[slug]"])
      });
    }
  